import { API_PATHS } from "./apiPaths";
import { axiosInstance } from "./axiosSetup";

export async function getClearSkiesList(selectedJournalIds) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      journal_ids: selectedJournalIds.join(',')
    },
    path: API_PATHS.CLEAR_SKIES_LIST,
    method: "get",
  });
}
